import { FC } from 'react';

import { Box, Flex, Hide, StyleProps } from '@bonusly/design-system';

import { AskBizyButton } from './AskBizyButton';
import { CompanyLogo } from './CompanyLogo';
import { ExternalLinks } from './ExternalLinks';
import { GoHomeButton } from './GoHomeButton';
import { useNavOptions } from './hooks/useNavOptions';
import { Nav } from './Nav';
import { ToggleSuperAdminControls } from './ToggleSuperAdminControls';
import { TrialBanner } from './trial-banner';

export const AdminNavbar: FC<StyleProps> = (props) => {
	const { admin, superAdmin } = useNavOptions();
	return (
		<Hide below="xs">
			<Flex data-testid="admin-navbar" as="nav" bgColor="bg.surface" flexDirection="column" {...props}>
				<Box borderBottomColor="border.default" borderBottomWidth={1}>
					<CompanyLogo />
					<GoHomeButton />
					<TrialBanner />
				</Box>
				<Flex flex={1} flexDirection="column" overflowY="auto" px={1}>
					<Nav nav={admin} />
					<ToggleSuperAdminControls />
					<Nav nav={superAdmin} />
					<Box mt="auto">
						<AskBizyButton />
						<ExternalLinks />
					</Box>
				</Flex>
			</Flex>
		</Hide>
	);
};
